import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

import withPreloadCheck from '../SiteSeeker/hocs/withPreloadCheck';

import {
  GOOGLE_API_ORIGIN,
  GOOGLE_API_MAP_PATH,
  GOOGLE_API_MAP_QUERY,
} from '../../../constants/google-maps';
import { GlobalsContext } from './context/globals';

const AsyncGoogleMap = withPreloadCheck(() => <div></div>);

const getGeocodeResult = (results) => {
  // ensure not the default USA, everything else is valid.
  results = results.filter((result) => {
    const parts = result.formatted_address.split(',');
    const countryPart = parts.pop().trim().toLowerCase();
    return countryPart !== 'usa';
  });

  if (results.length) {
    return results.shift();
  }

  return undefined;
};

const GetGeoData = ({ children, googleHasLoaded }) => {
  const [loading, setLoading] = useState(false);
  const [goggleHasLoaded, setGoogleHasLoaded] = useState(false);
  const {
    globals: {
      googleApiKey,
    },
  } = useContext(GlobalsContext);

  const getGeoData = (location, callBack) => {
    let data = {
      error: `Location is not defined: ${location}`,
    };

    if (location) {
      setLoading(true);

      const geocoder = new google.maps.Geocoder();
      const address = `${location}, uk`;

      geocoder.geocode({ address }, (results, status) => {
        data.error = `No GeoData returned for ${location}`;

        if (status === 'OK') {
          const result = getGeocodeResult(results);

          if (result) {
            if (result.geometry.location) {
              const latitude = parseFloat(result.geometry.location.lat().toFixed(6));
              const longitude = parseFloat(result.geometry.location.lng().toFixed(6));

              data = { latitude, longitude };
            }
          }
        }

        setLoading(false);
        callBack(data);
      });
    } else {
      callBack(data);
    }
  };


  const onContainerElementRender = () => {
    setGoogleHasLoaded(true);
    googleHasLoaded();
  };

  return (
    <>
      {goggleHasLoaded &&
        children({ loading, getGeoData })
      }
      <AsyncGoogleMap
        googleMapURL={`${GOOGLE_API_ORIGIN}${GOOGLE_API_MAP_PATH}${GOOGLE_API_MAP_QUERY.replace('{0}', googleApiKey)}`}
        loadingElement={<div></div>}
        containerElement={<div ref={onContainerElementRender}></div>}
        mapElement={<div></div>}
      />
    </>
  );
};

GetGeoData.propTypes = {
  children: PropTypes.func.isRequired,
  googleHasLoaded: PropTypes.func.isRequired,
};

export default GetGeoData;
